<style lang="less" scoped>
.first /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
.btnfixed {margin: 0px auto;height: 60px;z-index: 9999;}
.btnfixed .el-button {height: 40px;margin: 10px auto;margin-top: 10px;}
/deep/.el-icon-close-tip {display: none;}
</style>

<template>
  <div class="first" id="first">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="原密码" prop="oldPassword">
        <el-input type="password" placeholder="请输入原密码" v-model="ruleForm.oldPassword" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" placeholder="请输入6-16位大小写字母和数字组合"  v-model="ruleForm.newPassword" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="ConfirmPassword">
        <el-input type="password" placeholder="请输入确认密码"  v-model="ruleForm.ConfirmPassword" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="modification()">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data()
  {
    let validatePass1 = (rule, value, callback) =>
    {
      if (value === '')
        callback(new Error('请输入原密码'))
      else
        callback()
    }
    let validatePass2 = (rule, value, callback) =>
    {
      let regtel = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,16}$/
      if (value === '')
        callback(new Error('请输入新密码'))
      else
      {
        if (!regtel.test(value))
          callback(new Error('密码为6-16位大小写字母和数字组合，请重新输入'))
        else
          callback()
      }
    }
    let validatePass3 = (rule, value, callback) =>
    {
      if (value === '')
        callback(new Error('请输入确认密码'))
      else if (value !== this.ruleForm.newPassword)
        callback(new Error('两次输入密码不一致!'))
      else
        callback()
    }
    return {
      //fld表数据
      tableNameDate: [],
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        ConfirmPassword: '',
        userId: null
      },
      rules: {
        oldPassword: [
          { validator: validatePass1, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        ConfirmPassword: [
          { validator: validatePass3, trigger: 'blur' }
        ]
      }
    }
  },
  async created()
  {
    if (localStorage.getItem('username'))
      this.getuserId(localStorage.getItem('username'))
  },
  methods: {
    getuserId(username)
    {
      let obj = {
        cmd: 'query',
        _major: 99,
        _minor: 14,
        _exp: `name = ${username}`
      }
      window.post.getPost(obj).then(ret =>
      {
        if (ret.length === 1)
          this.ruleForm.userId = ret[0].id
      })
    },
    //确定修改
    modification()
    {
      this.$refs.ruleForm.validate(valid =>
      {
        if (valid)
        {
          let obj = {
            cmd: 'setPsw',
            oldpassword: this.ruleForm.oldPassword,
            newpassword: this.ruleForm.newPassword,
            _userId: this.ruleForm.userId
          }
          window.post.getLoginSvr(obj).then((ret) =>
          {
            if (ret.ret === 1)
              this.$message({message: '修改失败，请检查原密码是否正确', type: 'error', customClass: 'mzindex'})
            else
            {
              this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
              localStorage.removeItem('username')
              this.$router.push({path: '/loginindex'})
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/hyxx/Password.vue